// @ vendors
const { APIPost } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
// @actions
const notification = require('actions/notifications');

const removeWalletSuccess = (data, idPortfolioAccount, deletingPortfolioOnEdition) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_REMOVE_SUCCESS,
    payload: data,
    idPortfolioAccount: idPortfolioAccount,
    deletingPortfolioOnEdition: deletingPortfolioOnEdition
});

const removeWalletError = (data) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_REMOVE_ERROR,
    payload: data
});

const removeWalletRequest = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_REMOVE_REQUEST
});

const setPortfolioToDelete = (walletId, walletName, deletingOnEdition) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_REMOVE_DATA_CHANGED,
    customWalletIdToDelete: walletId,
    customWalletNameToDelete : walletName,
    deletingOnEdition: deletingOnEdition
});

const cancelDelete = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_REMOVE_CANCELED
});

const removeWallet = (deletingPortfolioOnEdition) => (dispatch, getState) => {
    const brokerCustomWalletPortfolios = getState().brokerCustomWalletPortfolios;
    const idPortfolioAccount = brokerCustomWalletPortfolios.get('customWalletIdToDelete');

    dispatch(removeWalletRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerCustomWalletRemove', { portfolioAccountId: idPortfolioAccount }))
        .then(response => {
            const message = formatText('brokerCustomWallet-deleteWalletSuccess');
            dispatch(notification.success({message}, {voice: message}));
            dispatch(removeWalletSuccess(response, idPortfolioAccount, deletingPortfolioOnEdition))
        })
        .catch(response => {
            const message = formatText('brokerCustomWallet-deleteWalletError');
            dispatch(notification.error({message}, {voice: message}));
            dispatch(removeWalletError(response.error))
        });
};

module.exports = {
    removeWallet,
    setPortfolioToDelete,
    cancelDelete,
};